<template>
  <section id="reset-password-page" class="mb-5">
    <div class="row justify-content-center">
      <div class="col-md-5 mt-5">
        <form @submit.prevent="resetPassword" id="reset-password-form">
          <div class="form-group m-label-left">
            <input
              type="email"
              class="form-control"
              id="email"
              aria-describedby="emailReset"
              v-model="email"
              required
            />
            <label for="email">Email Address</label>
          </div>

          <div class="form-buttons d-flex justify-content-between text-center">
            <button
              @click="resetPasswordButtton()"
              class="btn btn-secondary px-4"
              style="width: 45%"
            >
              Submit
            </button>
            <button @click="$emit('close')" class="btn btn-primary px-4" style="width: 45%">
              Cancel
            </button>
          </div>
        </form>
      </div>
      <Spinner :isLoading="isLoading" />
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { email } from 'vuelidate/lib/validators';
import Spinner from '../common/LoadingSpinner/Spinner';
export default {
  components: {
    Spinner,
  },
  data: () => ({
    isLoading: false,
    email: '',
    user: {
      email: null,
      errorMessage: null,
      user: {
        email: null,
      },
    },
  }),
  watch: {
    user: {
      handler() {
        this.errorMessage = null;
      },
      deep: true,
    },
  },
  methods: {
    resetPassword() {
      if (this.validUser()) {
        //TODO:: send req to server
      }
    },
    validUser() {
      const { email } = this.user;

      if (!email) {
        this.errorMessage = 'The email field cannot be empty!';

        return false;
      }

      return true;
    },
    resetPasswordButtton() {
      this.isLoading = true;
      if (this.email.length > 0) {
        axios(`${process.env.VUE_APP_API_URL}/auth/forgotpassword`, {
          method: 'post',
          data: {
            email: this.email,
          },
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(() => {
            this.isLoading = false;
            this.$emit('close');
            this.$toasted.success(
              'We sent you an email with instructions on how to reset your password.',
              {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              },
            );
          })
          .catch(() => {
            this.isLoading = false;
            this.$toasted.error('Please enter valid email address.', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
